<template>
    <div class="multi-bet-item-container full-white-border">
        <v-container fluid px-0 py-0>
            <h2 class="text-center multi-bet-header">MULTI BET</h2>
            <table>
                <thead></thead>
                <tbody>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="2" class="betslip-item-uppercase">Total Odds</td>
                        <td v-if="checkSuspendedGame(this.betSelections) === true"><i
                                class="material-icons lock-icon">lock</i></td>
                        <td v-else class="odds">
                            <transition name="oddIncrease">
                                <div v-if="getOddsUpdate(this.betSelections) === true">
                                </div>
                            </transition>
                            {{ totalOdds }}
                            <transition name="oddDecrease">
                                <div v-if="getOddsUpdate(this.betSelections) === false">
                                </div>
                            </transition>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </v-container>
        <v-container fluid px-0 py-0>
            <v-layout row wrap>

                <v-flex xs12 md6 class="border">
                    <v-text-field style="border-top: 1px solid #929292" @keypress="isNumber($event)" v-model="stake"
                        type=number :hide-details="hideTextFieldHints" min="0" max="99999999" box
                        color="blue-grey lighten-2" label="Total Stake" :disabled="$store.getters.getMultipleSubmitting"
                        @input="calculateTotalOddsAndPayout()" :class="'stake-box'" required></v-text-field>
                </v-flex>
                <v-flex xs12 md6 class="border">
                    <v-text-field style="border-top: 1px solid #929292; border-bottom:1px solid #929292;" v-model="payoutDisplay"
                        :hide-details="hideTextFieldHints" box color="blue-grey lighten-2" label="Total Payout"
                        disabled></v-text-field>
                </v-flex>
                <template v-if="$store.getters.getMultipleErrorMessage.indexOf('Price') !== -1">
                    <button class="btn-submit" color="green" v-on:click="acceptChanges()">
                        ACCEPT CHANGES
                    </button>
                </template>
                <template v-else-if="$store.getters.getMultipleAccepted">
                    <button class="btn-submit" color="blue" v-on:click="checkLoggedIn()">
                        SUBMIT MULTIPLE
                    </button>
                    <v-alert :value="$store.getters.getMultipleSuccess" dismissible type="success">
                        Bet Successfully Placed. <br /> Ticket No: {{ $store.getters.getMultipleTicketNumber }}
                    </v-alert>
                </template>
                <template v-else-if="!$store.getters.getMultipleAccepted">
                    <button :disabled="timeout || stake < 1 || marketStatusId || marketDetailStatus"
                        :class="[{'btn-submit': true, 'disabled-submitmultibet': (timeout || stake < 1 || marketStatusId || marketDetailStatus)}]"
                        v-on:click="checkLoggedIn()" color="blue">
                        {{ submitText }}
                </button>
                    <v-alert :value="$store.getters.getMultipleSuccess" dismissible type="success">
                        Bet Successfully Placed. <br /> Ticket No: {{ $store.getters.getMultipleTicketNumber }}
                    </v-alert>
                    <v-alert v-model="error" dismissible type="error">
                        {{ $store.getters.getMultipleErrorMessage }}
                    </v-alert>
                </template>
            </v-layout>
        </v-container>
    </div>
</template>

<script>

import Utils from '../utils/utils';
import Vue from 'vue';
import * as CONFIG from "../config"
import BetSlipApi from "../api/BetSlip"

export default {
    name: 'MultiBetItem',
    props: {
        betSelections: Array,
        betSubmit: Function,
    },
    data() {
        return {
            stake: null,
            payout: 0,
            payoutDisplay: null,
            totalOdds: 0,
            displayTotalOdds: 0,
            submitText: "SUBMIT MULTIPLE",
            timeout: false,
            countDown: 10,
            displayCountdown: 10,
            hideTextFieldHints: true,
            marketDetailStatus: false,
            marketStatusId: false,
            acceptedChanges: false,
            submittingNow: false,
            error: false
        }
    },
    computed: {
        Autheticated() {
            return this.$store.getters.isAutheticated
        },
    },
    methods: {
        checkSuspendedGame(betSelection) {
            for (var i = 0; i < betSelection.length; i++) {
                if (betSelection[i].marketDetailStatus === 2 || betSelection[i].marketStatusId === 2 || betSelection[i].betleg.odds === 0 || betSelection[i].betleg.odds === -1) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        getOddsUpdate(betSelection) {
            for (var i = 0; i < betSelection.length; i++) {

                if (betSelection[i].css === "oddIncrease") {
                    return true;
                }
                else if (betSelection[i].css === "oddDecrease") {
                    return false;
                }
            }
        },
        destroy(betSelection) {
            Vue.set(betSelection, 'css', '')
        },
        isNumber: function (evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (this.stake !== null && this.stake.length >= 8) {
                evt.preventDefault();
            }
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        getTotalOdds() {
            if (this.betSelections !== null) {
                this.totalOdds = 1;

                for (let i = 0; i < this.betSelections.length; i++) {
                    this.totalOdds = this.totalOdds * (this.betSelections[i].betleg.odds + 1);
                }
                this.totalOdds = Utils.roundDown(this.totalOdds - 1, 2);
                return Utils.roundDown((this.totalOdds), 2);
            }
        },
        calculateTotalOddsAndPayout() {
            var odds = 1;

            for (let i = 0; i < this.betSelections.length; i++) {
                odds = odds * (this.betSelections[i].betleg.odds + 1);
            }
            this.totalOdds = Utils.roundDown((odds - 1), 2);
            this.payout = this.stake * (odds - 1);
            this.payoutDisplay = Utils.roundDown(this.payout, 2);

            if (this.payoutDisplay <= 0) {
                this.payoutDisplay = null;
            }
        },
        checkLoggedIn() {
            if (this.$store.getters.getMultipleError) {
                this.$store.dispatch('setMultipleSubmission', { success: false, error: false, errorMessage: '', submitting: false, accepted: false });
                this.error = false
            }
            this.$store.dispatch('storeCookieAccessToken').then(() => {
                if (this.$store.getters.accessToken !== null) {
                    this.$store.dispatch('login', { authToken: this.$store.getters.accessToken }).then(async () => {
                        this.startBetSubmit();
                        var resp = await BetSlipApi.submitPreflightBetInfo();
                        if (resp) {
                            this.$store.dispatch('storeSubmitBetRequestId', resp.responseObject);
                        }
                    })
                } else {
                    this.$store.dispatch('setMultipleSubmission', { success: false, error: true, errorMessage: 'You need to be logged in to submit a bet', submitting: false, accepted: false });
                }
            });
        },
        updateMultipleInfo(stake, totalOdds, payout) {
            this.$store.dispatch('updateMultipleTotals', {
                totalStake: stake,
                totalOdds: totalOdds,
                totalPayout: payout
            });
        },
        startBetSubmit() {
            const currentBetSelections = Utils.deepClone(this.betSelections);
            this.setCountdownTimer(this.betSelections)
            let priceDrift = this.$store.getters.selectedOddsChange;
            this.$store.dispatch('setMultipleSubmission', { success: false, error: false, errorMessage: '', submitting: true, accepted: false });
            let localTotalOdds = this.totalOdds
            this.updateMultipleInfo(this.stake, localTotalOdds, this.payout);
            this.timeout = true;
            this.$store.dispatch('setIsSubmitting', true);

            this.countDown = this.countDown - 4;

            this.displayCountdown = this.countDown + 4;
            var setDisplayTimer = setInterval(() => {
                this.displayCountdown--;
                this.submitText = 'Wait ' + this.displayCountdown;

                if (this.displayCountdown === 0) {
                    clearInterval(setDisplayTimer);
                    this.submitText = 'SUBMIT MULTIPLE';
                    this.timeout = false;
                    this.$store.dispatch('setIsSubmitting', false);
                }
            }, 1000);

            var setCountDown = setInterval(() => {
                this.countDown--;
                if (this.countDown === 0) {
                    if (priceDrift === 'Accept any odds change') {
                        clearInterval(setCountDown);
                        this.calculateTotalOddsAndPayout();
                        this.updateMultipleInfo(this.stake, this.totalOdds, this.payout);
                        this.countDown = 10;
                        this.betSubmit(this.betSelections);
                    }
                    else if (priceDrift === 'Accept higher odds change') {
                        let oddsDecreased = true
                        for (let i = 0; i < currentBetSelections.length; i++) {
                            if (currentBetSelections[i].betleg.odds > this.betSelections[i].betleg.odds) {
                                oddsDecreased = false
                            }
                        }
                        if (oddsDecreased) {
                            clearInterval(setCountDown);
                            this.calculateTotalOddsAndPayout();
                            this.updateMultipleInfo(this.stake, this.totalOdds, this.payout);
                            this.countDown;
                            this.betSubmit(this.betSelections);
                        }
                        else {
                            clearInterval(setCountDown);
                            this.countDown;
                            this.betSubmit(currentBetSelections);
                        }
                    }
                    else {
                        clearInterval(setCountDown);
                        this.countDown;
                        this.betSubmit(currentBetSelections);
                    }
                }
            }, 1000);
            return this.countDown * 1000;
        },
        setCountdownTimer() {
            var sportNames = [];
            var sportTimes = [];

            for (const betSelection of this.betSelections) {
                sportNames.push(betSelection.sport);
            }

            for (const sportName of sportNames) {
                if (sportName === "RugbyUnion" || sportName === "RugbyLeague") {
                    sportTimes.push(CONFIG.MATCH_TIMERS.Rugby);
                }
                else if (sportName === "Tennis") {
                    sportTimes.push(CONFIG.MATCH_TIMERS.Tennis);
                } else if (sportName === "Cricket" || sportName === "TestCricket") {
                    sportTimes.push(CONFIG.MATCH_TIMERS.Cricket);
                } else if (sportName === "Basketball") {
                    sportTimes.push(CONFIG.MATCH_TIMERS.Basketball);
                } else if (sportName === "Football" || sportName === "Soccer") {
                    sportTimes.push(CONFIG.MATCH_TIMERS.Soccer);
                } else if (sportName === "AmericanFootball") {
                    sportTimes.push(CONFIG.MATCH_TIMERS.AmericanFootball);
                } else if (sportName === "AussieRules") {
                    sportTimes.push(CONFIG.MATCH_TIMERS.AussieRules);
                } else if (sportName === "Baseball") {
                    sportTimes.push(CONFIG.MATCH_TIMERS.Baseball);
                } else if (sportName === "Futsal") {
                    sportTimes.push(CONFIG.MATCH_TIMERS.Futsal);
                } else if (sportName === "TableTennis") {
                    sportTimes.push(CONFIG.MATCH_TIMERS.TableTennis);
                } else if (sportName === "Hockey") {
                    sportTimes.push(CONFIG.MATCH_TIMERS.Hockey);
                } else if (sportName === "BeachVolley") {
                    sportTimes.push(CONFIG.MATCH_TIMERS.BeachVolley);
                } else if (sportName === "HandBall") {
                    sportTimes.push(CONFIG.MATCH_TIMERS.HandBall);
                } else {
                    sportTimes.push(CONFIG.MATCH_TIMERS.Default);
                }
            }

            this.countDown = Math.max(...sportTimes);
        },
        acceptChanges() {
            this.$store.dispatch('setMultipleSubmission', { success: false, error: false, errorMessage: '', submitting: true, accepted: true });
            this.calculateTotalOddsAndPayout();
        },
    },
    mounted() {
        this.getTotalOdds()
        for (let i = 0; i < this.betSelections.length; i++) {
            this.$store.watch((state, getters) => getters.oddChange(this.betSelections[i] && this.betSelections[i].marketDetailId),
                (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        if (!this.$store.getters.getMultipleSubmitting) {
                            this.calculateTotalOddsAndPayout();
                        }
                    }
                });
            this.$store.watch((state, getters) => getters.marketStatusIdChange(this.betSelections[i] && this.betSelections[i].marketDetailId),
                (newValue) => {
                    if (newValue !== 1) {
                        this.marketStatusId = true;
                    }
                    else
                        this.marketStatusId = false;
                });
            this.$store.watch((state, getters) => getters.marketDetailStatusChange(this.betSelections[i] && this.betSelections[i].marketDetailId),
                (newValue) => {
                    if (newValue !== 1) {
                        this.marketDetailStatus = true
                    }
                    else
                        this.marketDetailStatus = false;
                });
        }
        this.$store.watch((state, getters) => getters.betSelectionCount,
            (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    if (!this.$store.getters.getMultipleSubmitting) {
                        this.calculateTotalOddsAndPayout()
                    }
                }
            });
        this.$store.watch((state, getters) => getters.getMultipleError,
            (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    this.error = newValue;
                }
            });
    }
}
</script>

<style scoped>
.odds {
    color: #F4EA22;
    font-weight: 700;
}

.border {
    border: 0px solid #FFFFFF !important;
}

.multi-bet-item-container {
    margin-top: 10px;
    padding: 0px;
    background-color: #ffffff;
}

.multi-bet-item-container button.btn-submit.v-btn {
    height: 30px;
    font-size: 12px;
}

.btn-submit {
    width: 100%;
    margin: 16px 0 0 0;
    color: white;
    display: inline-block;
    font-weight: 600;
    height: 40px;
    background: #8064E6;
    width: 100%;
    justify-content: center;
    align-items:center;
}

.text-center {
    text-align: center;
}

.multi-bet-header {
    text-transform: capitalize;
    background-color: #8064E6;
    padding: 8px 0px;
    font-size: 15px;
    font-weight: 300;
    margin-left: -10px;
    margin-right: -10px;
    height: 36px !important;
    text-align: center !important;
    padding-left: 20px;
}

.multi-bet-item-container .flex.border.xs12.md6 {
    -ms-flex-preferred-size: 100%;
    flex-basis: 100% !important;
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    max-width: 100% !important;
}

/*Single BetSlip CSS*/

.multi-bet-item-container tfoot td.odds {
    color: #8064E6;
    padding-right: 10px;
    font-weight: 700;
    background : #e6edff;
}

@media all and (-ms-high-contrast: none),
(-ms-high-contrast: active) {
    .odds {
        color: #F4EA22;
        font-weight: 700;
    }

    .oddIncrease-enter-active {
        right: 0px !important;
        bottom: 0px !important;
        top: 10px !important;
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent;
    }

    .oddDecrease-enter-active {
        right: 0px !important;
        bottom: 0px !important;
        top: 10px !important;
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent;
    }
}

@supports (-ms-ime-align:auto) {
    .odds {
        padding-right: 10px;
    }

    .oddIncrease-enter-active {
        right: 0px !important;
        bottom: 0px !important;
        transform: translateY(-8px);
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent;
    }

    .oddDecrease-enter-active {
        right: 0px !important;
        bottom: 0px !important;
        transform: translateY(-8px) rotate(90deg) !important;
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent;
    }
}

.border {
    border: 0px solid #fff !important;
}

@media (min-width:989px) {
    .border:last-child {
        border-left: none !important;
    }
}


.material-icons {
    color: red;
    font-weight: bolder;
    position: relative;
    left: 300px;
    font-size: 18px;
}

.disabledClick {
    pointer-events: none;
    cursor: default;
}

.disabledClick .material-icons {
    color: grey;
    font-weight: bolder;
}

.lock-icon {
    color: #616161;
    font-weight: bolder;
}

.detail-status {
    background: #616161;
    color: #fff;
    display: inline-block;
    border-radius: 3px;
    white-space: pre-wrap;
    font-size: 85%;
    font-weight: 900;
    line-height: 1.5;
    font-family: "Poppins";
    padding-left: 4px;
    padding-right: 4px;
    top: -1px;
    position: relative;
    margin-left: 100px;
}

.odds {
    color: gold;
    font-size: 12px;
    font-weight: 300;
    text-align: right;
}

.oddIncrease-enter-active {
    animation: increase 6s;
    /*position: absolute;*/
    bottom: 9px;
    right: -14px;
}

@keyframes increase {
    100% {
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent #2ad100 transparent transparent;
    }

    80% {
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent transparent transparent transparent;
    }

    60% {
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent #2ad100 transparent transparent;
    }

    40% {
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent transparent transparent transparent;
    }

    20% {
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent #2ad100 transparent transparent;
    }

    0% {
        border-style: solid;
        border-width: 0 10px 10px 0;
        border-color: transparent transparent transparent transparent;
    }
}

.oddDecrease-enter-active {
    right: 5px;
    /*transform: rotate(90deg);*/
    animation: decrease 6s;
}

@keyframes decrease {
    100% {
        border-style: solid;
        border-width: 10px 10px 0px 0;
        border-color: transparent #f50000 transparent transparent;
    }

    80% {
        border-style: solid;
        border-width: 10px 10px 0px 0;
        border-color: transparent transparent transparent transparent;
    }

    60% {
        border-style: solid;
        border-width: 10px 10px 0px 0;
        border-color: transparent #f50000 transparent transparent;
    }

    40% {
        border-style: solid;
        border-width: 10px 10px 0px 0;
        border-color: transparent transparent transparent transparent;
    }

    20% {
        border-style: solid;
        border-width: 10px 10px 0px 0;
        border-color: transparent #f50000 transparent transparent;
    }

    0% {
        border-style: solid;
        border-width: 10px 10px 0px 0;
        border-color: transparent transparent transparent transparent;
    }
}

.betslip-item {
    color: #efefef;
    font-size: 12px;
    font-weight: normal;
}

.box {
    padding: 10px;
    border: 1px solid #fff;
    border-radius: 2px;
    background-color: #2b2b2b;
    margin-top: 5px;
}

.betslip-item-header {
    color: white;
    font-size: 11px;
    line-height: 17px;
    padding-left: 10px;
    text-align: left;
    padding-bottom: 1px;
    text-transform: uppercase;
    width: 100%;
}

.multi-bet-item-container table {
    width: 100%;
    border-spacing: 0;
    background-color: #e6edff
}

.multi-bet-item-container table thead {
    width: 100%;
}

.multi-bet-item-container table thead td:nth-child(3) {
    padding-right: 15px;
}

.multi-bet-item-container tfoot td.odds {
    color: #8064E6;
    font-weight: 700;
}

.odds {
    color: #F4EA22;
    font-weight: 700;
}

.multi-bet-item-container .btn-submit.v-btn.theme--dark.blue {
    background-color: #8064E6 !important;
    color: #ffffff !important;
}

.bet-slip-item-container button.btn-submit {
    height: 30px;
    font-size: 12px;
}

.betslip-item-uppercase {
    color: #000000;
    background-color: #e6edff;
    font-size: 15px;
    padding: 0px 0px;
    text-transform: capitalize !important;
    font-weight: 300;
    padding-left: 10px;
    padding-top: 15px;
    padding-bottom: 10px;
}

@media(max-width:320px) {
    .box {
        padding: 5px 5px 5px 5px !important;
    }

    .betslip-item {
        font-size: 11px;
    }

    .betslip-item-header {
        font-size: 14px;
        padding-bottom: 0px;
    }

    .betslip-item-uppercase {
        font-size: 14px
    }

    .odds {
        color: #F4EA22;
        font-weight: 700;
    }
}

.bet-leg {
    font-size: 12px;
    font-weight: normal;
}

.text-center {
    text-align: center;
}

.section {
    background-color: #ffffff;
    padding: 7px 10px 0px 10px;
}

.v-label {
    font-size: 11px;
}

.disabled-submitmultibet{
    opacity: 0.5;  
}
</style>
